import React from 'react';
import { Box, Button, Chip, Stack, Typography } from '@mui/material';
import BaseHeader from '../headers/BaseHeader';

const tutorialUser = {
  name: 'チュートリアルユーザー',
  ticket: 2000,
  entryTicket: 1000,
};

const tutorialEvents = [
  {
    id: 'tutorial-main',
    name: 'チュートリアル用予想イベント',
    tags: ['はじめて', '練習'],
    createdLabel: 'イベント作成: たった今',
    roundLabel: 'ラウンド: 1 ラウンド目',
    allowedEntryTickets: 1,
    minimumBet: 10,
    maxBet: 100,
    description: '次のラウンドでどちらが勝つかを予想してみましょう。',
    ownerName: 'Betty運営',
    featured: true,
  },
  {
    id: 'tutorial-sports',
    name: 'サンプル: 野球の勝敗予想',
    tags: ['スポーツ'],
    createdLabel: 'イベント作成: 2時間前',
    roundLabel: 'ラウンド: 3 ラウンド目',
    allowedEntryTickets: 1,
    minimumBet: 1,
    maxBet: 50,
    description: '試合の展開を見ながら、結果を予想するテーブルです。',
    ownerName: 'sample-user',
  },
];

const sectionTitleSx = {
  padding: '8px 12px',
  margin: '24px 4px 8px 4px',
  backgroundColor: '#e0e0e0',
  borderRadius: '6px',
  fontWeight: 'bold',
  fontSize: '16px',
  color: '#333',
};

function TutorialHeader() {
  const linkBoxSx = {
    borderRadius: '3px',
    padding: '8px',
    color: '#fff',
    opacity: 0.92,
  };

  return (
    <BaseHeader>
      <Box sx={{ ...linkBoxSx, width: '40px' }}>TOP</Box>
      <Box sx={{ ...linkBoxSx, width: '175px' }}>イベントを作成</Box>
      <Box sx={{ ...linkBoxSx, width: '90px' }}>ランキング</Box>
      <Box sx={{ ...linkBoxSx, width: '80px' }}>検索</Box>
      <Box sx={{ ...linkBoxSx, width: '80px' }}>ログアウト</Box>
      <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0 }}>
        <Chip label="チュートリアル" size="small" sx={{ bgcolor: '#e0f2fe', color: '#075985', fontWeight: 900 }} />
        <Box sx={{ ...linkBoxSx, width: '180px', padding: '6px 8px' }}>
          <div>{tutorialUser.name}</div>
          <div>{tutorialUser.ticket.toLocaleString()} ポイント保有</div>
        </Box>
      </Box>
    </BaseHeader>
  );
}

function DailyPointMock() {
  return (
    <Box
      sx={{
        mx: { xs: 1.5, md: 3 },
        mt: 2,
        mb: 1,
        p: 2,
        borderRadius: '16px',
        border: '1px solid rgba(25, 118, 210, 0.28)',
        background: 'linear-gradient(135deg, rgba(227, 242, 253, 0.96) 0%, rgba(187, 222, 251, 0.88) 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        flexWrap: 'wrap',
      }}
    >
      <Box>
        <Box sx={{ fontSize: '15px', fontWeight: 800, color: '#12344d', mb: 0.5 }}>
          現在の保有ポイントは {tutorialUser.ticket.toLocaleString()}pt です
        </Box>
        <Box sx={{ fontSize: '13px', color: 'rgba(18, 52, 77, 0.8)' }}>
          イベントに参加すると、{tutorialUser.entryTicket.toLocaleString()}pt をこのイベントの持ち点として使います。
        </Box>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>
        <Chip label={`${tutorialUser.ticket.toLocaleString()}pt`} color="primary" />
        <Typography sx={{ fontWeight: 900, color: '#1d4ed8' }}>→</Typography>
        <Chip label={`${(tutorialUser.ticket - tutorialUser.entryTicket).toLocaleString()}pt`} color="warning" />
      </Box>
    </Box>
  );
}

function TutorialCallout() {
  return (
    <Box
      sx={{
        mx: { xs: 1.5, md: 3 },
        mt: 2,
        p: 2,
        borderRadius: 3,
        bgcolor: '#fff7ed',
        border: '1px solid #fed7aa',
      }}
    >
      <Typography variant="subtitle1" fontWeight={900} sx={{ color: '#9a3412' }}>
        ここはチュートリアル用トップです
      </Typography>
      <Typography sx={{ mt: 0.5, color: '#7c2d12', lineHeight: 1.7 }}>
        実際のテーブル一覧に似た画面で、Bettyの基本操作を順番に確認します。ここでの操作は本番データには影響しません。
      </Typography>
    </Box>
  );
}

function TutorialEventCard({ event }) {
  return (
    <Box
      sx={{
        maxWidth: 400,
        minWidth: 300,
        minHeight: 220,
        border: event.featured ? '2px solid #1976d2' : '1px solid #ccc',
        borderRadius: '8px',
        margin: '16px 4px',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 300px',
        backgroundColor: event.featured ? '#f0f7ff' : '#f9f9f9',
        boxShadow: event.featured ? '0 10px 24px rgba(25, 118, 210, 0.16)' : 'none',
      }}
    >
      <Box
        sx={{
          minHeight: 220,
          p: 2,
          boxSizing: 'border-box',
          display: 'flex',
          flex: '1 1 300px',
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 1,
        }}
      >
        <Stack direction="row" spacing={0.75} useFlexGap flexWrap="wrap">
          <Chip label="開催中" size="small" color="success" />
          {event.featured ? <Chip label="ここから練習" size="small" color="secondary" /> : null}
        </Stack>

        <Typography sx={{ fontSize: 18, fontWeight: 900 }}>
          {event.name}
        </Typography>

        <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
          {event.tags.map((tag) => (
            <Chip key={tag} label={tag} size="small" color="primary" />
          ))}
        </Stack>

        <Typography sx={{ fontSize: 12, color: '#666' }}>{event.createdLabel}</Typography>
        <Typography sx={{ fontSize: 12, color: '#666' }}>{event.roundLabel}</Typography>

        <Box sx={{ fontSize: 12, color: '#555', display: 'flex', justifyContent: 'space-between', gap: 1, flexWrap: 'wrap' }}>
          <span>必要チケット: {event.allowedEntryTickets}枚</span>
          <span>最小予想: {event.minimumBet}</span>
          <span>最大予想: {event.maxBet}</span>
        </Box>

        <Typography sx={{ fontSize: 14, color: '#555' }}>
          {event.description}
        </Typography>

        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1}>
          <Typography sx={{ fontSize: 12, color: '#888' }}>
            作成者: {event.ownerName}
          </Typography>
          {event.featured ? (
            <Button href="/tutorial/room" variant="contained" size="small" sx={{ fontWeight: 900 }}>
              参加する
            </Button>
          ) : null}
        </Stack>
      </Box>
    </Box>
  );
}

function TutorialEventList({ title, events }) {
  return (
    <>
      <Box sx={sectionTitleSx}>{title}</Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '16px',
          padding: '8px 0',
        }}
      >
        {events.map((event) => (
          <TutorialEventCard key={event.id} event={event} />
        ))}
      </Box>
    </>
  );
}

function TutorialTop() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fafafa', color: '#111827', pb: 5 }}>
      <TutorialHeader />
      <TutorialCallout />
      <DailyPointMock />
      <TutorialEventList title="最新のbetテーブル" events={tutorialEvents} />
    </Box>
  );
}

export default TutorialTop;
